export const DEEP_LEVEL_CATEGORIES = 0;
export const DEEP_LEVEL_GROUPS = 1;
export const DEEP_LEVEL_APARTMENTS = 2;
